// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { FilterMenu } from '@/components/filter-menu';
import {
  PROJECT_STATUS_LABELS,
  PROJECT_STATUS_SLUGS,
  ProjectStatusSlug,
  toProjectStatus,
} from '@/constants/project-status';

const DEFAULT_LABEL = 'Status';

interface Props {
  /**
   * An array of strings representing the currently selected project statuses.
   */
  value: ProjectStatusSlug[];

  /**
   * The label for the filter menu.
   *
   * @default "Status"
   */
  label?: string;

  /**
   * A callback fired when the selected project statuses change.
   */
  onChange: (value: ProjectStatusSlug[]) => void;
}

/**
 * A controlled filter menu for selecting zero or more project statuses from
 * the remote API.
 */
export function ProjectStatusFilterMenu(props: Props) {
  const label = props.label ?? DEFAULT_LABEL;
  const options = PROJECT_STATUS_SLUGS.map((slug) => ({
    id: slug,
    label: PROJECT_STATUS_LABELS[toProjectStatus(slug)],
    isActive: props.value.includes(slug),
  }));

  const handleChangeOption = (value: ProjectStatusSlug, isActive: boolean) => {
    if (isActive) {
      return props.onChange([...props.value, value]);
    }

    props.onChange(props.value.filter((status) => status !== value));
  };

  return (
    <FilterMenu
      label={label}
      options={options}
      onChangeOption={handleChangeOption}
    />
  );
}
